<template>
  <div>
    <el-col :span="6" class="mydoc title">
      <el-col class="header jump" @click.native="home()">
        <i class="el-icon-s-home"> </i> &nbsp;返回稿件列表
      </el-col>

      <el-col>&nbsp;</el-col>

      <el-col
        @click.native="isShow = 'submissionsComponent'"
        :class="{ active: isShow === 'submissionsComponent' }"
        class="catelog"
      >
        <span class="catelog_text">投稿须知</span>
        <el-divider></el-divider>
      </el-col>
      <el-col
        @click.native="isShow = 'manuscriptInfoComponent'"
        :class="{ active: isShow === 'manuscriptInfoComponent' }"
        class="catelog"
      >
        <span class="catelog_text"> 稿件信息</span>
        <el-divider></el-divider>
      </el-col>

      <el-col
        @click.native="isShow = 'authorInfoComponent'"
        :class="{ active: isShow === 'authorInfoComponent' }"
        class="catelog"
      >
        <span class="catelog_text">作者信息</span>
        <el-divider></el-divider>
      </el-col>

      <el-col
        @click.native="isShow = 'fileInfoComponent'"
        :class="{ active: isShow === 'fileInfoComponent' }"
        class="catelog"
      >
        <span class="catelog_text">文件上传</span>
        <el-divider></el-divider>
      </el-col>
      <el-col
        @click.native="isShow = 'recommendInfoComponent'"
        :class="{ active: isShow === 'recommendInfoComponent' }"
        class="catelog"
      >
        <span class="catelog_text">推荐审稿人/回避审稿人</span>
        <el-divider></el-divider>
      </el-col>
      <el-col
        @click.native="isShow = 'submitButtonComponent'"
        :class="{ active: isShow === 'submitButtonComponent' }"
        class="catelog"
      >
        <span class="catelog_text">提交稿件</span>
        <el-divider></el-divider>
      </el-col>
    </el-col>
    <el-col :span="17" class="mybody right">
      <component :is="isShow"></component>
    </el-col>
  </div>
</template>

<script>
import { getManuscriptsChargeInfo } from '@/api/data'
import submissionsComponent from '@/components/submissionsComponent'
import authorInfoComponent from '@/components/authorInfoComponent'
import manuscriptInfoComponent from '@/components/manuscriptInfoComponent'
import fileInfoComponent from '@/components/fileInfoComponent'
import recommendInfoComponent from '@/components/recommendInfoComponent'
import submitButtonComponent from '@/components/submitButtonComponent'

export default {
  name: 'submitManuscript',
  components: {
    submissionsComponent,
    authorInfoComponent,
    manuscriptInfoComponent,
    fileInfoComponent,
    recommendInfoComponent,
    submitButtonComponent,
    recommendInfoComponent,
    submitButtonComponent
  },
  data () {
    return {
      isShow: 'submissionsComponent',
      tabPosition: 'left',
      userInfo: null
    }
  },
  methods: {
    home () {
      const home = this
      home.$router.push({ name: 'manuscriptList' })
    },

    initModeification () {
      // console.log('LLLLLLLLLLLL')
      let flag = this.$route.query.flag
      if (flag == null) {
        return
      }
      getManuscriptsChargeInfo({
        manuscriptFlag: flag
      }).then((res) => {
        console.log(res)
        let oldManuscript = res.data.result.newest.manuscript
        if (
          oldManuscript.manuscriptStatus != 'refuse' &&
          oldManuscript.manuscriptStatus != 'second_refuse'
        ) {
          this.$message.error('稿件审批未完成，请勿重新上传')
          this.$router.replace('/index')
        }
        this.manuscripts.flag = flag
        this.manuscripts.title = oldManuscript.title
        this.manuscripts.category = oldManuscript.category
        this.manuscripts.abstracts = oldManuscript.abstracts
        this.manuscripts.manuscriptKeywords = oldManuscript.manuscriptKeywords
        this.authorsInfo = JSON.parse(oldManuscript.authorInfo)
        let reviewersInfo = JSON.parse(oldManuscript.reviewersInfo)
        this.reviewersInfo.recommends = reviewersInfo.recommends
        this.reviewersInfo.avoids = reviewersInfo.avoids
      })
    }
  },

  mounted () {
    let userInfo = this.$cookie.getCookie('userInfo')
    // if (userInfo == null || userInfo.type != "投稿人") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }

    this.userInfo = userInfo
    this.initModeification()
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    // box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
.title {
  height: 1200px;
  background-color: white;
  border: 1px solid #b3c0d1;
  border-radius: 6px;
}
.jump {
  font-weight: 900;
  cursor: pointer;
}
.catelog {
  cursor: pointer;
  text-align: left;
}
.catelog_text {
  margin-left: 30px;
}
.right {
  height: 1200px;
  border: 1px solid #b3c0d1;
  border-radius: 6px;
  background-color: white;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/contributor/submitManuscript.vue